<template>
  <div>
    <v-container class="pt-3 pb-6 px-6">

      <!-- Content -->
      <v-row align="center" justify="center">
        <!-- Table -->
        <v-col cols="12">
          <!-- Loading Bar -->
          <v-progress-linear
            indeterminate
            v-if="isLoadingData"
          ></v-progress-linear>
          <v-data-table
            v-if="authUser"
            :headers="headers"
            :items="interventions"
            :class="{'elevation-1': !flat}"
            :expanded.sync="expanded"
            show-expand
            :show-select="showSelect"
            @click:row="interventionReview($event)"
          >
            <!-- AG -->
            <template v-slot:item.ag="{ item }">
              {{ item.blade_damage[0] ? item.blade_damage[0].wind_turbine : '' }}
            </template>
            <!-- Start Date -->
            <template v-slot:item.start_date="{ item }">
              {{ item.work_intervention_day[0] ? formatDate(item.work_intervention_day[0].date) : '' }}
            </template>
            <!-- Operators -->
            <template v-slot:item.users="{ item }">
              <span v-if="item.users">
                <div v-for="(item, idx) in item.users" :key="item.id" >
                  <v-chip class="ma-1" light v-if="idx < 2">{{ operatorName(item) }}</v-chip>
                </div>
                <div class="pb-1" v-if="item.users.length > 2" >({{ item.users.length - 2 }} más)</div>
              </span>
            </template>
            <!-- State -->
            <template v-slot:item.state_id="{ item }">
              <v-chip :color="getColor(item.state_id)" :class="{'white--text': item.state_id !== STATE_TEXT.EN_REVISION}">
                {{ STATE_ID[item.state_id] }}
              </v-chip>
            </template>
            <!-- Expanded Row -->
            <template v-slot:expanded-item="{ headers, item }">
              <!-- Summary -->
              <td :colspan="reportHeaders ? headers.length / 2 : 6" class="text-center py-3">
                <div class="mb-3 font-weight-bold caption">Resumen</div>
                <div class="my-4">
                  <span class="error--text">{{ item.blade_damage && item.blade_damage.length || 0 }}</span> Daños
                    /
                  <span class="error--text"> {{ item.work_intervention_day && item.work_intervention_day.length || 0 }}</span> Días
                </div>
              </td>
              <!-- Operators -->
              <td
                v-if="item.users && item.users.length"
                :colspan="reportHeaders ? headers.length / 2 : 1"
                class="text-center py-3"
              >
                <span class="mx-1" v-for="(item, idx) in item.users" :key="idx">
                  <v-chip class="my-1 text-capitalize" v-if="idx >= 2">{{ operatorName(item) }}</v-chip>
                </span>
              </td>
              <td :colspan="2"></td>
            </template>
            <!-- No Data -->
            <template v-slot:no-data>
              No hay elementos
            </template>
            <!-- No Results -->
            <template v-slot:no-results>
              No hay elementos
            </template>
          </v-data-table>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import Util from "@/util/index";
import STATES from '@/models/States'

export default {
  props: {
    reportHeaders: { type: Array, default: null },
    work_order: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    showSelect: { type: Boolean, default: false },
    hideFilters: { type: Boolean, default: false },
    // TEST
      interventionsTEST: { type: Array, default: null }
    // TEST
  },
  data: () => ({
    selected: null,
    expanded: [],
    authUser: false,
    isLoadingData: false,
    workTypeItems: STATES.WORK_ORDER_TYPE,
    STATE_ID: STATES.INTERVENTION_REVIEW_STATE_ID,
    STATE_TEXT: STATES.INTERVENTION_REVIEW_STATE_TEXT,
    stateItems: STATES.INTERVENTION_REVIEW_STATES,
    headers: [
      { text: "Código Intervención", value: "id", align: "center", sortable: false },
      { text: "Tipo de trabajo", value: "work_order.work_type", align: "center" },
      { text: "Parque", value: "wind_farm.name", align: "center" },
      { text: "AG", value: "ag", align: "center", sortable: false },
      { text: "Fecha", value: "start_date", align: "center", sortable: false },
      { text: "Operarios", value: "users", align: "center", sortable: false },
      { text: "Estado", value: "state_id", align: "center" },
    ],
  }),
  computed: {
    interventions () {
      return this.$store.state.orders.interventions
    },
  },
  methods: {
    formatDate(date) {
      return Util.formatDate(date)
    },
    getColor(state) {
      if (state === this.STATE_TEXT.LISTA_PARA_VALIDAR) return ''
      if (state === this.STATE_TEXT.EN_REVISIÓN) return 'deep-orange'
      if (state === this.STATE_TEXT.EN_CURSO) return 'info'
      if (state === this.STATE_TEXT.VALIDADA) return 'primary'
    },
    text (item) {
      return item.lastName2
        ? item.firstName + ' ' + item.lastName1 + ' ' + item.lastName2
        : item.firstName + ' ' + item.lastName1
    },
    operatorName (item) {
      return item.last_name_2
        ? item.first_name + ' ' + item.last_name_1 + ' ' + item.last_name_2
        : item.first_name + ' ' + item.last_name_1
    },
    interventionReview (params) {
      const id = params.id
      this.$router.push({
        name: "intervention-review-edit",
        params: { id: id }
      });
    },
    init () {
      this.isLoadingData = true;
      const body = {
        id: this.$route.params.id,
        with: 'workOrder,users,windFarm,workInterventionDay,bladeDamage'
      }
      this.$store.dispatch('orders/getInterventions', body)
        .then(() => {
          this.authUser = true
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando la lista de intervenciones."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false
        })
    },
  },
  created () {
    this.init()
  }
}
</script>
